if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      // delete config.headers['Content-Type'];
      // headers: {
      //   'Content-Type': 'application/json'
      // },

      const formData = new FormData(this.form);
      // console.log(Object.fromEntries(formData.entries()));
      let formDataNew = {
        'items': []
      };
      let productData = {
        'id' : formData.get('id')
      };
      if(formData.get('properties')) {
        productData['properties'] = formData.get('properties')
      }
      if (this.cart) {
        // formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        // formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
        formDataNew['sections'] = this.cart.getSectionsToRender().map((section) => section.id)
        formDataNew['sections_url'] =  window.location.pathname
      }

      if(JSON.parse(this.dataset.showFinalSale) && JSON.parse(this.submitButton.dataset.onSale)) {
        // formData.append('properties[Sale]', 'Final')
        if(!productData.hasOwnProperty('properties')) {
          productData['properties']= {}
        }
        productData['properties']['Sale'] = 'Final'
      } else if(JSON.parse(this.submitButton.dataset.onFinalSale)) {
        // formData.append('properties[Sale]', 'Final')
        if(!productData.hasOwnProperty('properties')) {
          productData['properties']= {}
        }
        productData['properties']['Sale'] = 'Final'
      }
      if(this.submitButton.dataset.restrictedSale != 'false') {
        // formData.append('properties[Restricted]', this.submitButton.dataset.restrictedSale)
        if(!productData.hasOwnProperty('properties')) {
          productData['properties']= {}
        }
        productData['properties']['Restricted'] = this.submitButton.dataset.restrictedSale
      }
      formDataNew['items'][0]= productData
      
      if(formData.get('footbed')) {
        const timestamp = new Date().getTime();
        const footbedWidth = formData.get('footbed')
        console.log(footbedWidth)
        if(footbedWidth != 'standard') {
            const footbedJson = JSON.parse(document.getElementById('footbed-json').textContent);
            const footbedJsonHash = JSON.parse(document.getElementById('footbed-json-hash').textContent);
            const variantData = JSON.parse(document.querySelector('variant-radios [type="application/json"]').textContent);
            let hashValue = '';
            variantData.forEach((json)=>{
              if(json.id == formData.get('id')) {
                let size = parseInt(json.option2.replace(/\..*/, ''))
                footbedJsonHash.forEach((fJson) => {
                  if(fJson.option2 == size && fJson.option1 == footbedWidth) {
                    hashValue = fJson.hashValue
                  }
                })
                footbedJson.forEach((fJson) => {
                  if(fJson.option2 == size && fJson.option1 == footbedWidth) {
                    console.log(fJson);
                    formDataNew['items'].push({
                      'id' : fJson.id,
                      'properties': {
                        '__timestamp': timestamp,
                        '__complementary': timestamp + parseFloat(hashValue),
                        '__complementary_id': formData.get('id')
                      }
                    })
                  }
                })
              }
            })
        }
      }
      config.body = JSON.stringify(formDataNew);

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}

if (!customElements.get('product-form-alternate')) {
  customElements.define('product-form-alternate', class ProductFormAlternate extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
//       this.form.querySelector('[name=id-alternate]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if(this.form.querySelector('[name=id-alternate]')) {
        this.select = this.form.querySelector('[name=id-alternate]');
        this.select.addEventListener('change', this.onVariantChange.bind(this));
      } else {
        this.line = this.form.querySelector('[name=line]');
      }
        
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
    }

    onVariantChange() {
        if(this.select.selectedOptions) {
            const selected = this.select.selectedOptions[0]
            if(selected.dataset.img) {
                console.log(selected.dataset.img)
                console.log(this.select.closest('.product-item').querySelector('img'))
                this.select.closest('.product-item').querySelector('img').setAttribute('src', selected.dataset.img)
            }
        }
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      
      let url = `${routes.cart_add_url}`;
      if(this.line) {
        url = `${routes.cart_change_url}`;
      } else {
        const id = formData.get('id-alternate');
        formData.append('id', id)
        formData.delete('id-alternate')
      }


      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }

      config.body = formData;

      fetch(url, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}

if (!customElements.get('variant-radios')) {
    class VariantRadios extends HTMLElement {
    constructor() {
        super();
        this.addEventListener('change', this.onVariantChange);
        this.automaticDiscountConfig = this.parseAutomaticDiscountConfig();
        this.automaticDiscountExcludedVariantIds = this.getAutomaticDiscountExcludedVariantIds();
        const configuredDiscountPercent = Number(
            this.automaticDiscountConfig.percent ?? this.dataset.automaticDiscountPercent
        );
        if (Number.isFinite(configuredDiscountPercent)) {
            this.automaticDiscountPercent = Math.min(100, Math.max(0, configuredDiscountPercent));
        } else {
            this.automaticDiscountPercent = 0;
        }
        this.automaticDiscountEnabled = Boolean(
            this.automaticDiscountConfig.enabled ?? this.hasAttribute('data-automatic-discount-percent')
        );
        this.automaticDiscountLabel = String(
            this.automaticDiscountConfig.label ?? this.dataset.automaticDiscountLabel ?? ''
        ).trim();
        
        // TODO delay this further?
        if (document.readyState === 'loading') {  // Loading hasn't finished yet
            window.addEventListener('DOMContentLoaded', (event) => {
                this.processHiddenImages()
            });
        } else {
            this.processHiddenImages()
        }
        this.onVariantChange()
    }

    parseAutomaticDiscountConfig() {
        const configScript = document.getElementById('automatic-discount-config-json');
        if (!configScript || !configScript.textContent) return {};

        try {
            return JSON.parse(configScript.textContent);
        } catch (error) {
            console.warn('Failed to parse automatic discount config JSON', error);
            return {};
        }
    }

    normalizeAutomaticDiscountExcludedVariantIds(rawIds) {
        if (!rawIds) return new Set();

        const ids = Array.isArray(rawIds) ? rawIds : String(rawIds).split('|');
        return new Set(
            ids
                .map((id) => String(id).trim())
                .filter((id) => id.length > 0)
        );
    }

    getAutomaticDiscountExcludedVariantIds() {
        return this.normalizeAutomaticDiscountExcludedVariantIds(this.automaticDiscountConfig.excludedVariantIds);
    }

    processHiddenImages() {
    //       console.log('Loading hidden images');
        const images = document.querySelectorAll(`#shopify-section-${this.dataset.section} .product-media [data-src]`);
        if(images) {
            images.forEach((image)=>{
            const src = image.dataset.src;
            const srcset = image.dataset.srcset;
            image.setAttribute('srcset', srcset)
            image.setAttribute('src', src)
            })
        }
    }

    getAutomaticDiscountPrice(priceInCents) {
        const multiplier = (100 - this.automaticDiscountPercent) / 100;
        return Math.round(Number(priceInCents) * multiplier);
    }

    isAutomaticDiscountEligible(variant, hasAdminDiscount) {
        if (!variant || !variant.id) return false;
        if (Number(variant.price) <= 0) return false;
        if (!this.automaticDiscountEnabled) return false;
        if (this.automaticDiscountPercent <= 0) return false;
        if (hasAdminDiscount) return false;
        return !this.automaticDiscountExcludedVariantIds.has(String(variant.id));
    }

    getFlashSaleDiscountCents(variant) {
        const discountAmount = Number(variant && variant.flash_sale_discount_amount ? variant.flash_sale_discount_amount : 0);
        if (!Number.isFinite(discountAmount) || discountAmount <= 0) return 0;
        return Math.round(discountAmount * 100);
    }

    getFlashSaleLabel(variant) {
        return String(variant && variant.flash_sale_label ? variant.flash_sale_label : '').trim();
    }

    getFlashSalePromotionLabel(variant) {
        const label = this.getFlashSaleLabel(variant);
        return label;
    }

    getFlashSalePrice(variant) {
        const discountCents = this.getFlashSaleDiscountCents(variant);
        const price = Number(variant && variant.price ? variant.price : 0);
        if (price <= 0) return null;
        if (discountCents <= 0 || price <= discountCents) return price;
        return price - discountCents;
    }
    
    onVariantChange() {
        this.updateOptions();
        this.updateSelectedOptionValues();
        this.updateMasterId();
        this.updateVariantContent();
        this.updateOptionTwoAvailability();
        this.toggleAddButton(true, '', false);
        this.removeErrorMessage();

        if (!this.currentVariant) {
        this.updateColorMediaFromSelectedOption();
        this.toggleAddButton(true, '', true);
        this.setUnavailable();
        } else {
        this.updateMedia();
        this.updateURL();
        this.updateVariantInput();
        this.renderProductInfo();
        }
    }

    updateVariantContent() {
        const section = document.getElementById(`shopify-section-${this.dataset.section}`);
        if (!section) return;

        const description = this.currentVariant ? this.currentVariant.description : this.dataset.defaultDescription;
        const fit = this.currentVariant ? this.currentVariant.fit : this.dataset.defaultFit;
        const hasFitConfig = this.currentVariant
            ? this.currentVariant.has_fit_config
            : this.dataset.defaultHasFitConfig === 'true';
        const descriptionElement = section.querySelector('[data-product-description]');

        if (descriptionElement) {
            descriptionElement.innerHTML = description || '';
            descriptionElement.classList.toggle('hidden', !description);
        }

        const detailsDescription = this.currentVariant ? this.currentVariant.details_description : this.dataset.defaultDetailsDescription;
        const detailsDescriptionElement = section.querySelector('[data-product-details-description]');
        if (detailsDescriptionElement) {
            detailsDescriptionElement.innerHTML = detailsDescription || '';
        }

        const descriptionDetails = section.querySelector('[data-product-description-details]');
        if (descriptionDetails) descriptionDetails.classList.toggle('hidden', !detailsDescription);

        const fitElements = [
            ...section.querySelectorAll('[data-product-fit]'),
            ...document.querySelectorAll('.section-tabs [data-product-fit]')
        ];
        fitElements.forEach((element) => {
            element.innerHTML = fit || '';
        });

        const fitDetails = section.querySelector('[data-product-fit-details]');
        if (fitDetails) fitDetails.classList.toggle('hidden', hasFitConfig || !fit);
    }

    updateColorMediaFromSelectedOption() {
        if (!this.dataset.isColor || !this.options || !this.options[0]) return;

        const selectedColor = this.options[0];
        const colorHandle = selectedColor.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');
        const media = document.querySelectorAll(`#shopify-section-${this.dataset.section} .product-media [data-color]`);
        if (!media || !media.length) return;

        const colorVariant = this.getVariantData().find((variant) => variant.option1 === selectedColor);
        let firstColor = true;

        media.forEach((item) => {
            if (item.dataset.color === colorHandle) {
                item.classList.remove('hidden');
                if (firstColor) {
                    item.dataset.label = colorVariant && colorVariant.secondary_label ? colorVariant.secondary_label : '';
                    firstColor = false;
                }
            } else {
                item.classList.add('hidden');
            }
        });

        const badgeContainer = document.querySelector(`#shopify-section-${this.dataset.section} .product-media`);
        if (badgeContainer) {
            this.updateOfferBadgeElement(badgeContainer, colorVariant && colorVariant.offer_badge);
        }

        const swiperElement = document.querySelector(`#shopify-section-${this.dataset.section} .product-media.swiper`);
        const swiper = swiperElement ? swiperElement.swiper : null;
        if (swiper) {
            swiper.update();
        }
    }

    updateOptionTwoAvailability() {
        if (this.querySelectorAll('[data-option="3"]').length > 0) return;

        const sizeInputs = this.querySelectorAll(`[data-option="2"] [value]`);
        if (!sizeInputs || !sizeInputs.length) return;

        const selectedOptionOne = this.options && this.options[0] ? this.options[0] : null;
        if (!selectedOptionOne) return;

        const variants = this.getVariantData();

        sizeInputs.forEach((sizeInput) => {
            const matchingVariants = variants.filter((variant) => {
                return variant.option1 === selectedOptionOne && variant.option2 === sizeInput.value;
            });

            const hasAvailableMatch = matchingVariants.some((variant) => variant.available);
            const isUnavailable = matchingVariants.length === 0 || !hasAvailableMatch;

            sizeInput.classList.toggle('unavailable', isUnavailable);
            // Being "unavailable" is a visual-only state (the option stays selectable so
            // shoppers can see the sold-out message); expose it to assistive tech too.
            sizeInput.setAttribute('aria-disabled', isUnavailable ? 'true' : 'false');
        });
    }

    updateSelectedOptionValues() {
        const optionOneValue = this.querySelector(`[data-option="1"] .value`);
        const optionTwoValue = this.querySelector(`[data-option="2"] .value`);
        const optionThreeValue = this.querySelector(`[data-option="3"] .value`);

        if (optionOneValue) {
            optionOneValue.innerHTML = this.options && this.options[0] ? this.options[0].replace(/\//, '|') : '';
        }
        if (optionTwoValue) {
            optionTwoValue.innerHTML = this.options && this.options[1] ? this.options[1].replace(/\//, '|') : '';
        }
        if (optionThreeValue) {
            optionThreeValue.innerHTML = this.options && this.options[2] ? this.options[2].replace(/\//, '|') : '';
        }
    }

    updateMasterId() {
        this.currentVariant = this.getVariantData().find((variant) => {
        return !variant.options.map((option, index) => {
            return this.options[index] === option;
        }).includes(false);
        });
    }

    updateMedia() {
    //     if (!this.currentVariant) return;
    //     if (!this.currentVariant.featured_media) return;
    // 
    //     const mediaGalleries = document.querySelectorAll(`[id^="MediaGallery-${this.dataset.section}"]`);
    //     mediaGalleries.forEach(mediaGallery => mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true));
    // 
    //     const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    //     if (!modalContent) return;
    //     const newMediaModal = modalContent.querySelector( `[data-media-id="${this.currentVariant.featured_media.id}"]`);
    //     modalContent.prepend(newMediaModal);
    }

    updateURL() {
        if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
        let search = window.location.search.replace(/[\?\&]variant=\d+/,'').replace(/^[\?\&]/,'')
        let newState = `${this.currentVariant.product_url}?variant=${this.currentVariant.id}`
        if(search.length > 0) {
            newState+= '&' + search
        }
        window.history.replaceState({ }, '', newState);
        let event = new Event("product-url-change", {bubbles: true});
        document.body.dispatchEvent(event);
    }

    updateVariantInput() {
        const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`);
        productForms.forEach((productForm) => {
        const input = productForm.querySelector('input[name="id"]');
        input.value = this.currentVariant.id;
        input.dispatchEvent(new Event('change', { bubbles: true }));
        });
    }

    removeErrorMessage() {
        const section = this.closest('section');
        if (!section) return;

        const productForm = section.querySelector('product-form');
        if (productForm) productForm.handleErrorMessage();
    }

    renderProductInfo() {
    //     fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`)
    //       .then((response) => response.text())
    //       .then((responseText) => {
    //         const html = new DOMParser().parseFromString(responseText, 'text/html')
    //         const destination = document.getElementById(`price-${this.dataset.section}`);
    //         const source = html.getElementById(`price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
    //         if (source && destination) destination.innerHTML = source.innerHTML;
    // 
    //         const price = document.getElementById(`price-${this.dataset.section}`);
    // 
    //         if (price) price.classList.remove('visibility-hidden');
    //       });
    //     console.log(this.currentVariant)
        this.updateOptionTwoAvailability();

        var onSale = false,
            onFinalSale = false,
            restrictedSale = false;

        if(document.querySelector(`#price-${this.dataset.section} .final_sale_tag`)) {
            document.querySelector(`#price-${this.dataset.section} .final_sale_tag`).remove();
        }
        if (
          this.currentVariant.sale_type == 'Final Sale' &&
          this.currentVariant.compare_at_price &&
          this.currentVariant.compare_at_price > this.currentVariant.price
        ) {
            restrictedSale = `${window.variantStrings.finalSale}`
            let finalSaleTag = document.createElement('div')
            finalSaleTag.classList.add('final_sale_tag')
            finalSaleTag.innerHTML = `${window.variantStrings.finalSale} <span class="question_mark">?<span class="text">${window.variantStrings.finalSaleInfo}</span></span>`;
            document.querySelector(`#price-${this.dataset.section}`).append(finalSaleTag);
        } else if(this.currentVariant.sale_type == 'Exchange Only') {
            restrictedSale = `${window.variantStrings.exchangeOnly}`
            let finalSaleTag = document.createElement('div')
            finalSaleTag.classList.add('final_sale_tag')
            finalSaleTag.innerHTML = `${window.variantStrings.exchangeOnly} <span class="question_mark">?<span class="text">${window.variantStrings.exchangeOnlyInfo}</span></span>`;
            document.querySelector(`#price-${this.dataset.section}`).append(finalSaleTag);
        } else {
            restrictedSale = false;
        }
        const priceContainer = document.getElementById(`price-${this.dataset.section}`);
        const saleRegularPrice = document.querySelector(`#price-${this.dataset.section} .price__sale .price-item--regular`);
        const salePrice = document.querySelector(`#price-${this.dataset.section} .price__sale .price-item--sale`);
        const regularPrice = document.querySelector(`#price-${this.dataset.section} .price__regular .price-item--regular`);
        const discountPercent = document.querySelector(`#price-${this.dataset.section} .discount-percent`);
        const automaticDiscountBadge = document.querySelector(`#price-${this.dataset.section} .automatic-discount-badge`);
        const automaticDiscountBadgeLabel = document.querySelector(`#price-${this.dataset.section} .automatic-discount-badge__label`);
        if (!priceContainer) return;
        const flashSalePrice = this.getFlashSalePrice(this.currentVariant);
        const flashSaleLabel = this.getFlashSalePromotionLabel(this.currentVariant);
        const isFlashSale = flashSaleLabel.length > 0;
        const hasAdminDiscount = this.currentVariant.compare_at_price && this.currentVariant.compare_at_price > this.currentVariant.price;
        const isAutomaticDiscount = this.isAutomaticDiscountEligible(this.currentVariant, hasAdminDiscount || isFlashSale);

        if (isFlashSale) {
            priceContainer.classList.add('price--on-sale');
            if (saleRegularPrice) {
                saleRegularPrice.innerHTML = flashSalePrice < this.currentVariant.price ? formatMoney(this.currentVariant.price) : '';
            }
            if (salePrice) {
                salePrice.innerHTML = formatMoney(flashSalePrice);
            }
            if (regularPrice) {
                regularPrice.innerHTML = formatMoney(this.currentVariant.price);
            }
            if (discountPercent) {
                discountPercent.innerHTML = flashSaleLabel;
            }
            if (automaticDiscountBadge) {
                automaticDiscountBadge.classList.add('hidden');
            }
        } else if(hasAdminDiscount) {
            // if(this.currentVariant.final_sale == 'true') {
            //     if(document.querySelector(`#price-${this.dataset.section} .price__sale .final_sale_tag.forced`)) {
            //         document.querySelector(`#price-${this.dataset.section} .price__sale .final_sale_tag`).classList.remove('hidden')
            //         onFinalSale = true
            //     }
            // } else {
            //     if(document.querySelector(`#price-${this.dataset.section} .price__sale .final_sale_tag.forced`)) {
            //         document.querySelector(`#price-${this.dataset.section} .price__sale .final_sale_tag`).classList.add('hidden')
            //     }
            // }
            onSale = true;
            let discountPercentValue = Math.round((1 - this.currentVariant.price / this.currentVariant.compare_at_price) * 100);
            priceContainer.classList.add('price--on-sale');
            if (saleRegularPrice) {
                saleRegularPrice.innerHTML = formatMoney(this.currentVariant.compare_at_price);
            }
            if (salePrice) {
                salePrice.innerHTML = formatMoney(this.currentVariant.price);
            }
            if (regularPrice) {
                regularPrice.innerHTML = formatMoney(this.currentVariant.price);
            }
            if (discountPercent) {
                discountPercent.innerHTML = `${discountPercentValue}% OFF`;
            }
            if (automaticDiscountBadge) {
                automaticDiscountBadge.classList.add('hidden');
            }
        } else if (isAutomaticDiscount) {
            const automaticDiscountPrice = this.getAutomaticDiscountPrice(this.currentVariant.price);
            priceContainer.classList.add('price--on-sale');
            if (saleRegularPrice) {
                saleRegularPrice.innerHTML = formatMoney(this.currentVariant.price);
            }
            if (salePrice) {
                salePrice.innerHTML = formatMoney(automaticDiscountPrice);
            }
            if (regularPrice) {
                regularPrice.innerHTML = formatMoney(this.currentVariant.price);
            }
            if (discountPercent) {
                discountPercent.innerHTML = `${this.automaticDiscountPercent}% OFF`;
            }
            if (automaticDiscountBadge) {
                automaticDiscountBadge.classList.remove('hidden');
                if (automaticDiscountBadgeLabel) {
                automaticDiscountBadgeLabel.textContent = this.automaticDiscountLabel;
                }
            }
        } else {
            priceContainer.classList.remove('price--on-sale');
            if (saleRegularPrice) {
                saleRegularPrice.innerHTML = formatMoney(this.currentVariant.price);
            }
            if (salePrice) {
                salePrice.innerHTML = '';
            }
            if (regularPrice) {
                regularPrice.innerHTML = formatMoney(this.currentVariant.price);
            }
            if (discountPercent) {
                discountPercent.innerHTML = '';
            }
            if (automaticDiscountBadge) {
                automaticDiscountBadge.classList.add('hidden');
            }
        }
        if(this.currentVariant.material && this.querySelector(`.material`)) {
            this.querySelector(`.material`).innerHTML = this.currentVariant.material;
        } else if(this.querySelector(`.material`)) {
            this.querySelector(`.material`).innerHTML = '';
        }
        if(this.currentVariant.option1) {
            this.querySelector(`[data-option="1"] .value`).innerHTML = this.currentVariant.option1.replace(/\//, '|');
        } else if(this.querySelector(`[data-option="1"] .value`)) {
            this.querySelector(`[data-option="1"] .value`).innerHTML = '';
        }
        if(this.currentVariant.option2) {
            this.querySelector(`[data-option="2"] .value`).innerHTML = this.currentVariant.option2.replace(/\//, '|');
        } else if(this.querySelector(`[data-option="2"] .value`)) {
            this.querySelector(`[data-option="2"] .value`).innerHTML = '';
        }
        if(this.currentVariant.option3) {
            this.querySelector(`[data-option="3"] .value`).innerHTML = this.currentVariant.option3.replace(/\//, '|');
        } else if(this.querySelector(`[data-option="3"] .value`)) {
            this.querySelector(`[data-option="3"] .value`).innerHTML = '';
        }
        if(this.dataset.isColor) {
            const media = document.querySelectorAll(`#shopify-section-${this.dataset.section} .product-media [data-color]`)
            if(media) {
                const color = this.currentVariant.option1.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');
                let firstColor = true
                media.forEach((item)=>{
                    if(item.dataset.color == color) {
                        item.classList.remove('hidden')
                        if(firstColor) {
                            item.dataset.label = this.currentVariant.secondary_label
                            firstColor = false
                        }
                    } else {
                        item.classList.add('hidden')
                    }
                })
                const badgeContainer = document.querySelector(`#shopify-section-${this.dataset.section} .product-media`)
                if (badgeContainer) {
                    this.updateOfferBadgeElement(badgeContainer, this.currentVariant.offer_badge)
                }
                const swiper = document.querySelector(`#shopify-section-${this.dataset.section} .product-media.swiper`).swiper;
                if(swiper) {
    //                 swiper.destroy(false, false);
                    swiper.update()
                }
            }
        }
        if(this.currentVariant.available) {
            document.getElementById(`product-form-${this.dataset.section}`).classList.remove('unavailable');
        } else {
            document.getElementById(`product-form-${this.dataset.section}`).classList.add('unavailable');
        }
        if(JSON.parse(this.currentVariant.limited) && this.querySelector(`[data-option="1"]`)) {
            this.querySelector(`[data-option="1"]`).classList.add('limited');
        } else if(this.querySelector(`[data-option="1"]`)) {
            this.querySelector(`[data-option="1"]`).classList.remove('limited');
        }
        const lowStock = document.querySelector('[data-product-inventory]')
        if(lowStock) {
            if(this.currentVariant.inventory_quantity > 0 && this.currentVariant.inventory_quantity <= lowStock.dataset.productInventory) {
                lowStock.querySelector('span').innerHTML = this.currentVariant.inventory_quantity;
                lowStock.classList.remove('hidden')
            } else {
                lowStock.classList.add('hidden')
            }
        }
        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut, true, onSale, this.currentVariant.retired, this.currentVariant.custom_unavailable_text, onFinalSale, restrictedSale);
        
        window.itemFav = window.itemFav || {}
        window.itemFav.Price = formatMoney(this.currentVariant.price);
        window.itemFav.CompareAtPrice = formatMoney(this.currentVariant.compare_at_price);
        window.itemFav.URL = `${window.shopUrl}${this.currentVariant.product_url}?variant=${this.currentVariant.id}`;
        window.itemFav.ImageURL = `${this.currentVariant.featured_image.src}`;

        if(this.currentVariant.option1) {
            const colorHandle = this.currentVariant.option1.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '')
            const genderLinks = document.querySelectorAll(`[data-color-${colorHandle}]`)
            if(genderLinks.length > 0) {
                genderLinks.forEach((link)=>{
                    link.setAttribute('href', link.getAttribute(`data-color-${colorHandle}`))
                })
            }
        }
//         if(window.ElevarGtmSuite){
//             ElevarGtmSuite.utils.pushToDataLayer({
//                 "event": "ws_image_fix",
//                 "ecommerce": {
//                     "add": {
//                         "products": [
//                             {
//                                 "image": window.itemFav.ImageURL,
//                             }
//                         ]
//                     }
//                 }
//             })
//         }
    }

    toggleAddButton(disable = true, text, modifyClass = true, onSale = false, retired = false, customText = '', onFinalSale = false, restrictedSale = false) {
        const productForm = document.getElementById(`product-form-${this.dataset.section}`);
        if (!productForm) return;
        const addButton = productForm.querySelector('[name="add"]');
        const addButtonText = productForm.querySelector('[name="add"] > span');
        const floatingButton = addButton.closest('form').querySelector('.product-form-floating button[name="add"]') || addButton.closest('form').querySelector('floating-form .product-form__submit');
        const floatingButtonText = addButton.closest('form').querySelector('.product-form-floating button[name="add"] > span') || addButton.closest('form').querySelector('floating-form .product-form__submit > span');
        if (!addButton) return;
        
        if(JSON.parse(retired)) {
            text = window.variantStrings.unavailable
        } else if(customText.length > 0) {
            text = customText
            addButton.dataset.customText = true
            if(floatingButton) {
                floatingButton.dataset.customText = true
            }
        } else {
            addButton.dataset.customText = false
            if(floatingButton) {
                floatingButton.dataset.customText = false
            }
        }

        if (disable) {
            addButton.setAttribute('disabled', 'disabled');
            if(floatingButton) {
                floatingButton.setAttribute('disabled', 'disabled');
            }
            if (text) {
                addButtonText.textContent = text;
                if(floatingButtonText) {
                    floatingButtonText.textContent = text;
                }
            }
        } else {
            addButton.removeAttribute('disabled');
            addButtonText.textContent = window.variantStrings.addToCart;
            if(floatingButton) {
                floatingButton.removeAttribute('disabled');
                floatingButtonText.textContent = window.variantStrings.addToCart;
            }
        }
        
        addButton.dataset.onSale = onSale
        addButton.dataset.onFinalSale = onFinalSale
        addButton.dataset.retired = retired
        addButton.dataset.restrictedSale = restrictedSale

        if (!modifyClass) return;
    }

    setUnavailable() {
        const button = document.getElementById(`product-form-${this.dataset.section}`);
        const addButton = button.querySelector('[name="add"]');
        const addButtonText = button.querySelector('[name="add"] > span');
        const floatingButtonText = button.querySelector('.product-form-floating button[name="add"] > span');
        const price = document.getElementById(`price-${this.dataset.section}`);
        if (!addButton) return;
        addButtonText.textContent = window.variantStrings.unavailable;
        if (floatingButtonText) {
            floatingButtonText.textContent = window.variantStrings.unavailable;
        }
        if (price) price.classList.add('visibility-hidden');
    }

    getVariantData() {
        this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
        return this.variantData;
    }

    updateOfferBadgeElement(mediaItem, offerBadge) {
        const badgeEl = mediaItem.querySelector('.offer-badge');
        if (!badgeEl) return;

        if (offerBadge && offerBadge.name) {
            badgeEl.innerHTML = offerBadge.name;
            badgeEl.style.backgroundColor = offerBadge.background_color || '';
            badgeEl.style.color = offerBadge.color || '';
            badgeEl.classList.remove('hidden');
        } else {
            badgeEl.innerHTML = '';
            badgeEl.removeAttribute('style');
            badgeEl.classList.add('hidden');
        }
    }

    updateOptions() {
        const fieldsets = Array.from(this.querySelectorAll('fieldset'));
        this.options = fieldsets.map((fieldset) => {
        return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
        });
    }
    }

    customElements.define('variant-radios', VariantRadios);
}

if (!customElements.get('floating-form')) {
    class FloatingForm extends HTMLElement {
    constructor() {
        super();
        this.form = document.getElementById(`product-form-${this.dataset.section}`);
    //     product-form-template--15086110244937__main-product
    //     template--15086110244937__main-product
    //     let addToCart = document.querySelector('.template-product .cta-content');
    //     let addToCartForm = document.querySelector('.template-product .shopify-product-form .js-qty');
        this.observer = new IntersectionObserver((entries, observer) => { 
        entries.forEach(entry => {
            if(entry.intersectionRatio!=1){
                this.classList.add('active');
            }
            else {
                this.classList.remove('active');
            }
        });
        }, {threshold: 1});
        if(this.form) {
            this.observer.observe(this.form);
        }
    }

    }

    customElements.define('floating-form', FloatingForm);
}
